export * from "./block.module";
export * from "./block.component";


// WEBPACK FOOTER //
// /app/src/app/layout/block/index.ts